<template>
    <div>
        <div class="d-flex justify-space-between align-center" v-if="!$store.state.baseLoading">
            <v-btn icon="mdi-arrow-right" variant="text" @click="$store.commit('setActivePage',backPage)"></v-btn>
            <h3>{{ $store.state.info.direct_title }}</h3>

            <v-btn v-if="$store.getters.getAuthToken == ''" 
                    :disabled="$store.state.baseLoading"
                    variant="outlined" 
                    @click="$store.commit('setLoginDialogStatus', true)">
                {{ $t('booking.login_button') }}
            </v-btn>
            
            <v-menu v-else>
                <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" icon="mdi-account" variant="text"></v-btn>
                </template>
                <v-list class="text-center">
                    <v-list-item>
                        {{ $t('booking.welcome_message', { mobile: $store.state.mobile }) }}
                    </v-list-item>
                    <v-list-item
                    @click="$store.commit('setActivePage', 'orders_history');">
                        لیست رزروها
                    </v-list-item>
                    <v-list-item
                    @click="$store.state.showProfileDialogStatus=true">
                        پروفایل
                    </v-list-item>
                    <v-list-item @click="$store.dispatch('logout')" class="text-red">
                        {{ $t('booking.logout_button') }}
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
        <v-progress-linear v-else indeterminate color="white" class="my-6"></v-progress-linear>
    </div>
</template>

<script>
export default {
    props:{
        backPage:{
            type:String,
            default:"splash",
            required:true
        }
    },
    data(){
        return{
        }
    },
    methods: {
    },
}
</script>